import { render, staticRenderFns } from "./FormDrilldownOption.vue?vue&type=template&id=87e968c2&scoped=true"
import script from "./FormDrilldownOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormDrilldownOption.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FormDrilldownOption.vue?vue&type=style&index=0&id=87e968c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e968c2",
  null
  
)

export default component.exports